// extracted by mini-css-extract-plugin
module.exports = {"root":"DocumentUpload-module__root--2c4Pz Layout-module__form--1UjW6"};